import { useSelector, useDispatch } from "react-redux";
import { 
    fetchInsurances, 
    createInsurances, 
    updateInsurances, 
    deleteInsurances 
} from "../../../redux/resources/resourcesSlice";
import { useCallback } from "react";
import { RootState } from '../../../redux';
import { AppDispatch } from '../../../redux';

const useFetchInsuranceResource = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { insurances, isLoading, error, status } = useSelector(
        (state: RootState) => state.resources
    );

    const fetchInsuranceData = useCallback(async () => {
        try {
            await dispatch(fetchInsurances()).unwrap();
        } catch (error) {
            console.error('Failed to fetch insurances:', error);
            throw error;
        }
    }, [dispatch]);

    return { 
        insurances, 
        isLoading, 
        error,
        status,
        fetchInsuranceData 
    };
};

const useAddInsurance = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { isLoading, error, status } = useSelector(
        (state: RootState) => state.resources
    );

    const addNewInsurance = useCallback(async (insuranceData: any) => {
        try {
            const result = await dispatch(createInsurances(insuranceData)).unwrap();
            return result;
        } catch (error) {
            console.error('Failed to add insurance:', error);
            throw error;
        }
    }, [dispatch]);

    return {
        addNewInsurance,
        isLoading,
        error,
        status
    };
};

const useUpdateInsurance = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { isLoading, error, status } = useSelector(
        (state: RootState) => state.resources
    );

    const updateExistingInsurance = useCallback(async (id: string, insuranceData: any) => {
        try {
            const payload = { id, ...insuranceData };
            const result = await dispatch(updateInsurances(payload)).unwrap();
            return result;
        } catch (error) {
            console.error('Failed to update insurance:', error);
            throw error;
        }
    }, [dispatch]);

    return {
        updateExistingInsurance,
        isLoading,
        error,
        status
    };
};

const useDeleteInsurance = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { isLoading, error, status } = useSelector(
        (state: RootState) => state.resources
    );

    const deleteExistingInsurance = useCallback(async (insuranceId: string) => {
        try {
            const result = await dispatch(deleteInsurances(insuranceId)).unwrap();
            return result;
        } catch (error) {
            console.error('Failed to delete insurance:', error);
            throw error;
        }
    }, [dispatch]);

    return {
        deleteExistingInsurance,
        isLoading,
        error,
        status
    };
};

export {
    useAddInsurance,
    useFetchInsuranceResource,
    useUpdateInsurance,
    useDeleteInsurance
};